import React from 'react';
import { CollapseIcon, ExpandIcon, MinusIcon, PlusIcon } from './lib';

export default function Controls({
  className = '',
  fullScreen,
  setFullScreen,
  zoomIn,
  zoomOut,
}) {
  return (
    <div className={className || 'siteplan__controls'}>
      <button
        aria-label="Expand"
        className="siteplan__expand"
        onClick={() => setFullScreen(!fullScreen)}
        type="button"
      >
        {fullScreen ? <CollapseIcon /> : <ExpandIcon />}
      </button>

      <button
        aria-label="Zoom in"
        className="siteplan__control siteplan__control--in"
        onClick={() => zoomIn()}
        type="button"
      >
        <PlusIcon />
      </button>
      <button
        aria-label="Zoom out"
        className="siteplan__control siteplan__control--out"
        onClick={() => zoomOut()}
        type="button"
      >
        <MinusIcon />
      </button>
    </div>
  );
}
